const routers = [
    {
        path: '/office_space',
        name: 'office_space',
        meta: {
            exp: '办公空间-列表',
            requireAuth: false
        },
        component: () => import('@/views/office_space/index.vue'),
    },
    {
        path: '/office_space_detail',
        name: 'office_space_detail',
        meta: {
            exp: '办公空间-详情',
            requireAuth: false
        },
        component: () => import('@/views/office_space/detail/index.vue'),
    },
    {
        path: '/investment_info',
        name: 'investment_info',
        meta: {
            exp: '园区-列表',
            requireAuth: false
        },
        component: () => import('@/views/investment_info/index.vue'),
    },
    {
        path: '/investment_info_park_detail',
        name: 'investment_info_park_detail',
        meta: {
            exp: '园区-详情',
            requireAuth: false
        },
        component: () => import('@/views/investment_info/park_detail/index.vue'),
    },
    {
        path: '/investment_info_office_space',
        name: 'investment_info_office_space',
        meta: {
            exp: '园区-内办公空间列表',
            requireAuth: false
        },
        component: () => import('@/views/investment_info/park_detail/office_space/index.vue'),
    },
    
    
]
export default routers